import { jsx as t } from "react/jsx-runtime";
import { Children as l, cloneElement as o } from "react";
import '../../assets/EqualSizeGrid.css';const m = {};
function u({ children: s, gap: a = "1.5rem", itemsPerRow: i = 4, classname: n = "" }) {
  const e = l.toArray(s);
  return /* @__PURE__ */ t(
    "equal-size-grid",
    {
      style: {
        "--esg-gap-size": a,
        "--esg-template-columns": `repeat(${i}, 1fr)`
      },
      "data-item-count": e.length,
      class: n,
      children: e.map((r) => /* @__PURE__ */ t(
        "div",
        {
          className: m["equal-size-grid__item"],
          children: o(r, r.props)
        },
        `esfr-${Math.round(Math.random() * 1e7)}`
      ))
    }
  );
}
export {
  u as EqualSizeGrid,
  u as default
};
